import React, { useMemo } from 'react';
import { CONTENT_TYPES } from '../../LearningPaths.utils';
import styles from './FocusLearningPaths.module.scss';
import { useHistory } from 'react-router-dom';
import FocusContentCard from '../LearningPathDetails/FocusContentCard';

const FocusLearningPathsContents = ({ learningPath = {} }) => {
  // Navigate to selected module
  const history = useHistory();
  const goToModule = (uuid) => {
    if (!uuid) return;
    history.push(`/training/${uuid}`, { rep_lp_id: learningPath.uuid });
  };
  const contents = useMemo(
    () => learningPath?.contents.sort((a, b) => a.status - b.status),
    [learningPath]
  );

  return (
    <>
      {contents.some((l) => l?.status === 2) && (
        <div className={styles.focusStatusLabel}>In Progress</div>
      )}
      <div className={styles.contents}>
        {[2].map((i) => {
          return contents
            .filter((a) => a.status === i)
            .map((path) => {
              return (
                <div key={path?.content?.uuid}>
                  <FocusContentCard
                    contentData={{ ...path, content_type: CONTENT_TYPES.TRAINING_MODULES }}
                    onClick_ = {() => goToModule(path?.content?.uuid)}
                  />
                </div>
              );
            });
        })}
      </div>
      {contents.some((l) => l?.status === 1) && (
        <div className={styles.focusStatusLabel}>Yet to Start</div>
      )}
      <div className={styles.contents}>
        {[1].map((i) => {
          return contents
            .filter((a) => a.status === i)
            .map((path) => {
              return (
                <div key={path?.content?.uuid}>
                  <FocusContentCard
                    contentData={{ ...path, content_type: CONTENT_TYPES.TRAINING_MODULES }}
                    onClick_ = {() => goToModule(path?.content?.uuid)}
                  />
                </div>
              );
            });
        })}
      </div>
      {contents.some((l) => l?.status === 3) && (
        <div className={styles.focusStatusLabel}>Completed</div>
      )}
      <div className={styles.contents}>
        {[3].map((i) => {
          return contents
            .filter((a) => a.status === i)
            .map((path) => {
              return (
                <div key={path?.content?.uuid}>
                  <FocusContentCard
                    contentData={{ ...path, content_type: CONTENT_TYPES.TRAINING_MODULES }}
                    onClick_ = {() => goToModule(path?.content?.uuid)}
                  />
                </div>
              );
            });
        })}
      </div>
    </>
  );
};

export default FocusLearningPathsContents;
